import React from 'react'
import { Table, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import filterItemsBy from '../../../helpers/content/manageSets/filterItemsBy'
import filterByNodes from '../../../helpers/content/manageSets/filterByNodes'
import filterAndSortItems from '../../../helpers/content/manageSets/filterAndSortItems'
import filterAndSortSets from '../../../helpers/content/manageSets/filterAndSortSets'
import findActiveItems from '../../../helpers/content/manageSets/findActiveItems'
 
import { SetItemPlusMinus, SetItemRow, } from '../ManageSetsComponents'

/*
  <SetItemsList 
    items={props.items} 
    filters={props.filters} 
    sets={props.sets}
    activeSet={props.activeSet}
    nodes={props.nodes}
    handleAddContentToSet={props.handleAddContentToSet}
    handleRemoveContentFromSet={props.handleRemoveContentFromSet}
  />
*/

export default function SetItemsList (props) {

  // ***************************** Compute active items ************************
  let activeSet
  if (props.sets && props.activeSet) {
    activeSet = props.sets[props.activeSet]
  }
  const activeItems = findActiveItems(activeSet)

  // **************************************************************************

  // ****************************** Build itemRows Components *****************
  let itemRows = []

  const sortedFilteredItems = filterAndSortItems(
                                props.filters, props.items, 
                                props.nodes, activeItems
                              )

  sortedFilteredItems.forEach((item) => {
    itemRows.push(
      <SetItemRow 
        activeItems={activeItems}
        contentType={item.contentType}
        itemType={item.itemType}
        question={item.question}
        name={item.name}
        itemId={item.itemId}
        key={`item${item.itemId}`}
        handleAddContentToSet={props.handleAddContentToSet}
        handleRemoveContentFromSet={props.handleRemoveContentFromSet}
      />
    )
  })

  const sortedFilteredSets =  filterAndSortSets(
                                props.filters, props.sets, 
                                props.nodes, activeItems, 
                                props.activeSet
                              )

  sortedFilteredSets.forEach((set) => {
    itemRows.push(
      <SetItemRow 
        activeItems={activeItems}
        contentType={set.contentType}
        itemType={''}
        question={''}
        name={set.name}
        itemId={set.id}
        key={`set${set.id}`}
        handleAddContentToSet={props.handleAddContentToSet}
        handleRemoveContentFromSet={props.handleRemoveContentFromSet}
        setType={set.setType}
      />
    )
  })

  itemRows === [] ? itemRows = <tr></tr> : null
  
  // **************************************************************************

  return (
    <Table responsive size='sm'>
      <thead>
        <tr>
          <th>ContentType</th>
          <th>SetType</th>
          <th>Name</th>
          <th>ItemType</th>
          <th>Question</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {itemRows}
      </tbody>
    </Table>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemsList.js